import React from "react";
import { changeCollection } from "../api/collection";

export default function useCollectionChange(onSuccess) {
  const [pending, setPending] = React.useState(false);
  const [error, setError] = React.useState(null);
  const request = React.useRef(null);
  const busy = React.useRef(false);
  const active = React.useRef(true);
  React.useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
    };
  }, []);

  const run = async (change) => {
    if (busy.current) return;
    // A failed remote write may already have changed Discogs. Keep its target.
    if (!request.current) request.current = Object.freeze({ ...change });
    busy.current = true;
    setPending(true);
    setError(null);
    let result;
    try {
      result = await changeCollection(request.current);
    } catch (failure) {
      if (active.current) setError(failure);
    } finally {
      busy.current = false;
      if (active.current) setPending(false);
    }
    if (result && active.current) {
      request.current = null;
      onSuccess(result);
    }
  };
  return {
    pending,
    error,
    request: request.current,
    run,
    retry: () => run(request.current),
  };
}
